import { useQuery } from "@tanstack/react-query";

import { WEBAPP_API_URL } from "api/ky";

const fetchTrustpilotRating = async () => {
  const response = await fetch(`${WEBAPP_API_URL}/api/airhelp_score`);

  const data = await response.json();

  return data;
};

interface TrustpilotApiResponse {
  totalReviews: number;
  scoreValue: number;
}

const useFetchTrustpilotRating = () => {
  return useQuery<TrustpilotApiResponse>({
    queryKey: ["trustpilotRating"],
    queryFn: () => fetchTrustpilotRating(),
  });
};

export default useFetchTrustpilotRating;
